import { Badge, cx } from "./ui.tsx";

export const fmtBytes = (n: number | null | undefined) => {
  if (n === null || n === undefined) return "—";
  const u = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < u.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v >= 10 || i === 0 ? v.toFixed(0) : v.toFixed(1)} ${u[i]}`;
};

export const fmtUsd = (n: number) => (n < 0.01 && n > 0 ? "<$0.01" : `$${n.toFixed(2)}`);

const phaseTone = { running: "good", starting: "accent", provisioning: "accent", stopped: "neutral", error: "bad" } as const;
const phaseLabel = { running: "Running", starting: "Starting", provisioning: "Setting up", stopped: "Stopped", error: "Error" } as const;

export function PhaseBadge({ phase }: { phase: keyof typeof phaseTone }) {
  return (
    <Badge tone={phaseTone[phase]}>
      <span className={cx("mr-1.5 inline-block h-1.5 w-1.5 rounded-full", phase === "running" ? "bg-emerald-500" : phase === "error" ? "bg-red-500" : phase === "stopped" ? "bg-[var(--muted)]/50" : "animate-pulse bg-[var(--color-brand)]")} />
      {phaseLabel[phase]}
    </Badge>
  );
}

export function UsageBar({ used, total, label }: { used: number | null; total: number | null; label?: string }) {
  const pct = used !== null && total ? Math.min(100, (used / total) * 100) : 0;
  const tone = pct > 90 ? "bg-red-500" : pct > 75 ? "bg-amber-500" : "bg-[var(--chart)]";
  const track = pct > 90 ? "bg-red-500/15" : pct > 75 ? "bg-amber-500/15" : "bg-[var(--chart)]/15";
  return (
    <div className="min-w-32">
      <div className={cx("h-1.5 overflow-hidden rounded-full", track)}>
        <div className={cx("h-full rounded-full transition-all", tone)} style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-1 text-xs text-[var(--muted)]">{label ?? (used === null ? "Not measured yet" : `${fmtBytes(used)} of ${fmtBytes(total)}`)}</div>
    </div>
  );
}

const eventTone = { oom: "bad", error: "bad", restarted: "accent", started: "good", stopped: "neutral", provisioned: "good", resized: "accent", skill: "accent" } as const;
export function EventBadge({ type }: { type: string }) {
  return <Badge tone={eventTone[type as keyof typeof eventTone] ?? "neutral"}>{type === "oom" ? "Out of memory" : type}</Badge>;
}
